import { render } from "./MMDetailNews.vue?vue&type=template&id=c099bf18&scoped=true"
import script from "./MMDetailNews.vue?vue&type=script&lang=js"
export * from "./MMDetailNews.vue?vue&type=script&lang=js"

import "./MMDetailNews.vue?vue&type=style&index=0&id=c099bf18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c099bf18"]])

export default __exports__